
import { defineComponent, onMounted, ref, Ref } from "vue";
import { api } from "@/services/reports/api";
import { apiExcel } from "@/services/reports/apiExcel";
import { ComisionesComisiones } from "@/types/reports/comisiones/comisionesComisiones/ComisionesComisiones";
import { ComisionFilter } from "@/types/comisiones/ComisionView";
import loading from "@/components/loading.vue";
import footerPage from "@/components/footerPage.vue";
import excelExport from "@/components/excelExport.vue";

export default defineComponent({
  name: "Listado1",
  components: {
    loading,
    footerPage,
    excelExport
  },
  setup() {
    const report: Ref<ComisionesComisiones> = ref({
      totalGeneralImporteComision: "",
      fabricantes: []
    });

    const detail = ref(true);

    const isLoading = ref(true);

    async function getReport() {
      isLoading.value = true;
      const filterString = localStorage.getItem("comisionFilter");
      let filter = {} as ComisionFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      //console.log('hola');
      const response = await api.getReportComisionesComisionesDB(filter);
      report.value = response;
      //console.log(report);
      isLoading.value = false;
    }

    async function getExcel() {
      const filterString = localStorage.getItem("comisionFilter");
      let filter = {} as ComisionFilter;
      if (filterString != undefined) filter = JSON.parse(filterString);
      apiExcel.getReportComisionesComisionesDB(filter);
    }

    onMounted(getReport);

    return {
      report,
      detail,
      isLoading,
      getExcel
    };
  }
});
